import { render } from "./DealSellerRule.vue?vue&type=template&id=128f0098&scoped=true"
const script = {}

import "./DealSellerRule.vue?vue&type=style&index=0&id=128f0098&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128f0098"]])

export default __exports__